module.exports = __webpack_public_path__ + "static/1p-96c337e5ba47fe8dfd6ba26fbcb6be2e.jpg";